import { render, staticRenderFns } from "./RSDocumentManager.vue?vue&type=template&id=f5710164&scoped=true&"
import script from "./RSDocumentManager.vue?vue&type=script&lang=js&"
export * from "./RSDocumentManager.vue?vue&type=script&lang=js&"
import style0 from "./RSDocumentManager.vue?vue&type=style&index=0&id=f5710164&lang=scss&scoped=true&"
import style1 from "./RSDocumentManager.vue?vue&type=style&index=1&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f5710164",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/codebuild/output/src1477836768/src/github.com/FebosIO/Febos-AMI/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('f5710164')) {
      api.createRecord('f5710164', component.options)
    } else {
      api.reload('f5710164', component.options)
    }
    module.hot.accept("./RSDocumentManager.vue?vue&type=template&id=f5710164&scoped=true&", function () {
      api.rerender('f5710164', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/febos/global/customDocuments/components/repository-selector/RSDocumentManager.vue"
export default component.exports